import { render, staticRenderFns } from "./stock-transfer-list.vue?vue&type=template&id=fada399e"
import script from "./stock-transfer-list.vue?vue&type=script&lang=js"
export * from "./stock-transfer-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports